import { useQuery } from '@tanstack/react-query';
import { useTranslate } from '@tolgee/react';
import { Select } from 'antd';
import { useSearchContext } from '../Context';
import { getSupplementKnowledgeSpuClassList } from 'services/api/supplementKnowledge';

export const SpuClassSelect = () => {
  const { t } = useTranslate();
  const { includeSpuClassId, setParams } = useSearchContext();

  const { data, isLoading } = useQuery({
    queryKey: ['getSpuClassList'],
    queryFn: () => {
      return getSupplementKnowledgeSpuClassList();
    },
  });

  return (
    <Select
      value={includeSpuClassId}
      onChange={(value) => {
        setParams({ includeSpuClassId: value });
      }}
      placeholder={t('请选择单品')}
      showSearch
      loading={isLoading}
      allowClear
      showArrow={false}
      className="w-[160px]"
      options={data?.map((item) => ({
        label: item.name,
        value: item.id,
      }))}
    />
  );
};

SpuClassSelect.displayName = 'ItemSelectV5SpuClassSelect';
